/* eslint-disable */
import React from "react";
import AssignmentsContainer from "../../components/assignments/AssignmentsContainer";

//NOTE:  When setting up a new top level menu, please set visible to false and set requiredRoles accordingly
//       visible prop is managed in menuReducer based on user role.
//       If the menu is supposed to show for everyone, set the requiredRoles to an empty array or undefined

export default  [
    {
        id: "MyAssignments",
        display: "Assignments",
        path: "/assignments",
        exact: false,
        isSecured: true,
        componentToRender: () => <AssignmentsContainer/>,
        menus: [],
        requiredRoles: ["None"],
        visible: false
    },
    {
        id: "ManageAssignments",
        display: "Assignments",
        path: "/assignments/manage",
        exact: false,
        isSecured: true,
        componentToRender: () => <AssignmentsContainer/>,
        menus: [],
        requiredRoles: ["Admin"],
        visible: false
    }
];
